import React from "react";
import { formatDate } from "./helpers";
// import { formatDate } from "../utils/helpers";

const BookingInfoHeader = ({ booking }) => (
    <div className="hourly-float-photographer-modal-header float-photographer-modal-header">
        <h3>Float Booking</h3>

        <div className="booking-info-grid">
            <InfoItem label="Booking ID"  value={booking?.veroaBookingId || booking?.bookingId} />
            <InfoItem label="Amount"      value={(booking?.bookingAmount || booking?.finalAmount || booking?.totalAmount) ? `₹ ${(booking?.bookingAmount || booking.finalAmount || booking.totalAmount).toLocaleString()}` : null} />
            <InfoItem label="Event Type"     value={booking?.eventType || "Editing"} />
            <InfoItem label="Location"       value={booking?.location || booking?.eventAddress} />
            <InfoItem
                label="Delivery Date"
                value={formatDate(
                    booking?.endDate ||
                        booking?.bookingDate ||
                        booking?.eventDate ||
                        booking?.startDate
                )}
            />
        </div>
    </div>
);

const InfoItem = ({ label, value }) => (
    <div className="booking-info-item">
        <span>{label}</span>
        <p>{value || "-"}</p>
    </div>
);

export default BookingInfoHeader;
